import classes from "./Section9.module.css";

export default function Section9() {
  return (
    <div className={classes.section9Wrapper}>
      <div className={classes.section9Container}>
        {cardsItem.map((item, index) => (
          <div key={index} className={classes.section9Content}>
            <div className={classes.section9Icon}>
              <img src={item.icon} alt={item.title} />
            </div>
            <div className={classes.section9Text}>
              <h4>{item.title}</h4>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

const cardsItem = [
  {
    icon: "./img/home-img/section-9/shipping.svg",
    title: "Free Shipping",
    desc: "Enjoy free worldwide shipping and returns, with customs and duties taxes included.",
  },
  {
    icon: "./img/home-img/section-9/return.svg",
    title: "Free Returns",
    desc: "Free returns within 15 days, please make sure the items are in undamaged condition.",
  },
  {
    icon: "./img/home-img/section-9/support.svg",
    title: "Support Online",
    desc: "We support customers 24/7, send questions we will solve for you immediately.",
  },
  {
    icon: "./img/home-img/section-9/price.svg",
    title: "Best Prices",
    desc: "We offer competitive prices without compromising quality.",
  },
];
